





























import Vue from 'vue'
import { parseItem } from './utils/parser'
import LoadingView from './components/LoadingView.vue'
import ErrorView from './components/ErrorView.vue'
import SlideViewer from './components/SlideViewer.vue'
import SlideControl from './components/SlideControl.vue'
import { Item } from '@/types/item'
import { fetchItem } from './utils/http'

interface LocalState {
  isFetched: boolean
  isErrored: boolean
  item: Item | null
  page: number
  pages: string[]
  errorReason: string | null
}

export default Vue.extend({
  name: 'Kamishibai',
  props: {
    itemid: String,
    apikey: {
      type: String,
      required: false,
      default: ''
    }
  },
  data(): LocalState {
    return {
      isFetched: false,
      isErrored: false,
      item: null,
      page: 0,
      pages: [],
      errorReason: ''
    }
  },
  components: {
    SlideViewer,
    SlideControl,
    LoadingView,
    ErrorView
  },
  computed: {
    option(): { apikey: string; version: string } {
      const apikey = this.apikey
      return {
        apikey,
        version: '1.0.6'
      }
    }
  },
  methods: {
    handleMoveToPrev() {
      this.page = Math.max(0, this.page - 1)
    },
    handleMoveToNext() {
      this.page = Math.min(this.pages.length - 1, this.page + 1)
    },
    handleMoveToPage(page: number) {
      this.page = page
    }
  },
  async mounted() {
    if (!this.itemid) {
      this.isErrored = true
      this.errorReason = '記事 ID が指定されていません。'
    }
    try {
      const item = await fetchItem(this.itemid, { token: this.option.apikey })
      this.item = item
      this.pages = parseItem(item)
      this.isFetched = true
    } catch (e) {
      this.isErrored = true
    }
  }
})
